<template>
  <div class="rights">
    <div class="rights-header">
      <img @click="closePage" src="@/assets/imageIntegral/close-black.png" alt="">
      <div>权益详情</div>
      <div></div>
    </div>
    <div class="rights-content">
      <tab-component :tabValue="tabValue" :titleList="tabTitle" @change="change" />
      <swiper
        class="swiper"
        :slides-per-view="1.1"
        :space-between="0"
        :loop="false"
        :centeredSlides="true"
        :initialSlide="tabValue"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide
          class="swiper_slide"
          v-for="(item, index) in imgList"
          :key="'right' + index"
        >
          <img :src="item" style="width: 100%">
          <div class="equity_record_box" v-if="item.includes('回升') && equityArray.length > 0">
            <p>权益使用记录</p>
            <div class="equity_record_detail">
              <template v-if="equityArray.filter(item => item.state == 2 || item.state == 3).length > 0">
                <div v-for="item in equityArray.filter(item => item.state == 2 || item.state == 3)" :key="item.time">
                  <div class="info">
                    <span>{{ item.label }}</span>
                    <span>{{ item.value }}</span>
                  </div>
                  <div class="time">{{ item.time }}</div>
                </div>
              </template>
              <template v-else>暂无数据</template>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { 
  defineComponent, 
  reactive, 
  toRefs, 
  onMounted, 
  getCurrentInstance, 
  watch,
} from 'vue';
import { Swiper } from 'swiper/vue/swiper.js';
import { SwiperSlide } from 'swiper/vue/swiper-slide.js';
import 'swiper/swiper.scss';
import { useStore } from 'vuex';
import request from '@/utils/request.js';
import * as api from '@/utils/apiIntegral.js';
import TabComponent from '@/components/tabComponent.vue';
import { 
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  imgRecoverBannerLV3,
  imgRecoverBannerLV4,
  imgQuickRecoverBannerLV4,
} from './imgImport.js';

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
    TabComponent,
  },
  setup() {
    const { beacon } = getCurrentInstance().appContext.config.globalProperties
    const store = useStore()
    const data = reactive({
      tabValue: 0,
      isPass:true,//是否是第一次进
      tabTitle:[],
      swiper: null,
      imgList: [],
      equityArray: [], // 展示在详情中内容
      equityArrayResult: [], // 接口返回的所有权益详情
      haveOpenId: null, // 是否传openId
      originLevel: 0, // 当前用户等级
      isEquity: 0, // 0 未使用 1 使用中
      currentLevel: 0,// 用户等级
      level: 0,// 滑块等级
    });
    const closePage = () => {
      window.history.back();
    };
    const change = (index) => {
      // console.log(index);
      data.tabValue = index;
      data.swiper.slideTo(index);
    }
    const onSwiper = (swiper) => {
      // console.log(swiper);
      data.swiper = swiper;
    };
    const onSlideChange = (event) => {
      // console.log(event);
      data.tabValue = event.realIndex;
    };
    watch(() => data.tabValue, (nv) => {
      if(data.isPass){
        data.isPass = false
        return
      }else{
        beacon.onUserAction('privilege_detail_switch',{
          switch_privilege_name: data.tabTitle[nv]
        })
      }
      if(data.equityArrayResult.length > 0){
        const value = data.tabTitle[data.tabValue]
        data.equityArray = data.equityArrayResult.filter(item => 
        value == '等级回升' ? item.label.includes('等级回升') : item.label.includes('等级快速回升'))
      }
    })
    onMounted(() => {
      data.haveOpenId = store.getters.haveOpenId || null
      const search = window.location.search.substring(1).split('&');
      const tabLevel = window.location.search.split('tabLevel=')[1].substring(0, 1)
      search.forEach(item => {
        if (item.indexOf('tab') !== -1) {
          const tab = item.split('=');
          data.tabValue = tab[1] * 1;
          change(tab[1] * 1);
        }
        if(item.indexOf('level') != -1){
          const level = item.split('=')[1]
          const imgList = [img0,img1,img2,img3,img4,img5]
          const tabTitle = ['可领取任务类型', '任务占用上限', '线上活动', '积分兑换', '线下见面会', '功能优先体验']
          data.currentLevel = level;
          data.level = tabLevel;
          // 当前等级是3 或者 滑块对应的等级是3
          if(tabLevel == 3){
            tabTitle.push('等级回升')
            imgList.push(imgRecoverBannerLV3) 
          }else if(tabLevel == 4){
            // 当前等级是4 或者 滑块对应的等级是4
            tabTitle.push('等级回升', '等级快速回升')
            imgList.push(imgRecoverBannerLV4, imgQuickRecoverBannerLV4)
          }
          data.imgList = imgList;
          data.tabTitle = tabTitle
        }
        if(item.indexOf('isEquity') != -1){
          data.isEquity = item.split('=')[1]
        }
      })
      // 获取权益使用记录
      getEquityRecord()
      beacon.onUserAction('privilege_detail_show',{
        privilege_name: data.tabTitle[data.tabValue]
      })
    });
    const getEquityRecord = async () => {
      let obj = {
        common: {
          "vcode":"31000008",
          "version":"3.10.0",
        },
      }
      let openId = store.getters.userInfo ? 
        store.getters.userInfo.split('/')[0] : null;
      data.haveOpenId ? obj['common']['openid'] = openId : ''
      const recordRes = await request('post', api.userEquityRecord, obj)
      console.log(recordRes, 'recordRes');
      if(recordRes.code == 0 && recordRes.data.length > 0 && data.currentLevel == data.level){
        // const recordData = recordRes.data.filter(item => item.state == 2)
        const recordData = recordRes.data
        recordData.map(item => {
          if((data.currentLevel == 4 && (item.equityType == 2 || item.equityType == 1))
          || (data.currentLevel == 3 && item.equityType == 3)){
            data.equityArrayResult.push({
              label: item.equityType == 1 ? '等级快速回升特权使用' : '等级回升特权使用',
              value: '-1次',
              time: item.userTime,
              state: item.state
            })
          }
        })
        const value = data.tabTitle[data.tabValue]
        data.equityArray = data.equityArrayResult.filter(item => 
        value == '等级回升' ? item.label.includes('等级回升') : item.label.includes('等级快速回升'))
      }
    }
    return {
      ...toRefs(data),
      closePage,
      change,
      onSwiper,
      onSlideChange,
      getEquityRecord,
    }
  },
})
</script>

<style lang="scss" scoped>
.rights {
  background-color: #F4F4FB;
  height: 100%;
  .rights-header {
    padding: 13px 20px 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    img {
      width: 20px;
    }
    div:first-of-type {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .swiper {
    margin-top: 14px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }
  .swiper_slide img{
    box-shadow: 2px 2px 19px rgba(219,227,241,0.78), 
    2px 2px 19px rgba(219,227,241,0.78);
  }
  .equity_record_box{
    position: absolute;
    width: 76%;
    bottom: 7%;
    left: 50%;
    height: 36%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    p{
      font-size: 16px;
      margin: 0 0 10px;
      font-weight: bold;
    }
    .equity_record_detail{
      background-color: rgb(242,242,242);
      flex: 1;
      padding:10px 15px;
      & > div {
        margin-top: 5px;
      }
      .info{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: bold;
      }
      .time{
        color: rgb(170, 170, 170);
        margin-top: 5px;
      }
    }
  }
}
</style>
